// extracted by css-extract-rspack-plugin
export default {"cls1":"SidebarComments-cls1_mk_","cls2":"SidebarComments-cls2_R5Q SidebarComments-cls1_mk_"};